const NavbarItems = [
  {
    title: "Home",
    url: "/#home",
    cname: "nav-links",
    hash: "#introduction",
  },
  {
    title: "How it works",
    url: "/#how-it-works",
    hash: "#how-it-works",
    cname: "nav-links",
  },
  {
    title: "Supported Platforms",
    url: "/#supported-platforms",
    hash: "#supported-platforms",
    cname: "nav-links",
  },

  {
    title: "Who we are",
    url: "/#who-we-are",
    hash: "#who-we-are",
    cname: "nav-links",
  },
  {
    title: "Collaborate with us",
    url: "/#collaborate",
    hash: "#collaborate",
    cname: "nav-links",
  },
  {
    title: "Publications",
    url: "/#literature",
    hash: "#literature",
    cname: "nav-links",
  },
];

export default NavbarItems;
